import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PeopleIcon from "@material-ui/icons/People";
import PlayForWork from "@material-ui/icons/NoteAdd";
import HomeIcon from "@material-ui/icons/Home";
import BarChartIcon from "@material-ui/icons/BarChart";
import PieChartIcon from "@material-ui/icons/PieChart";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import EmailIcon from "@material-ui/icons/Email";
import GroupAdd from "@material-ui/icons/GroupAdd";
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';

export const SideBarMenu = (props) => {
  const {
    handleHomeClick,
    handlePeopleClick,
    handleNewUsersClick,
    handleDailyMetricsClick,
    handleMiscMetricsClick,
    handleAdminRolesClick,
    handleUpdateEmailClick,
    handleFeatureAccessClick,
    handleManagePartnersClick,
    permissions,
  } = props;
  const handlePartnersClick =
    handleManagePartnersClick;

  return (
    <div>
      <ListItem button onClick={handleHomeClick} component={"ul"}>
        <ListItemIcon>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>

      <ListItem button onClick={handlePeopleClick} component={"ul"}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItem>

      <ListItem button onClick={handleNewUsersClick} component={"ul"}>
        <ListItemIcon>
          <PlayForWork />
        </ListItemIcon>
        <ListItemText primary="New Users" />
      </ListItem>

      <ListItem button onClick={handleDailyMetricsClick} component={"ul"}>
        <ListItemIcon>
          <PieChartIcon />
        </ListItemIcon>
        <ListItemText primary="Daily Metrics" />
      </ListItem>

      <ListItem button onClick={handleMiscMetricsClick} component={"ul"}>
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Misc. Metrics" />
      </ListItem>

      {permissions.includes("MR") && (
        <ListItem button onClick={handleAdminRolesClick} component={"ul"}>
          <ListItemIcon>
            <AccountTreeIcon />
          </ListItemIcon>
          <ListItemText primary="Admin Roles" />
        </ListItem>
      )}

      {permissions.includes("MR") && (
        <ListItem button onClick={handleUpdateEmailClick} component={"ul"}>
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText primary="Change Email" />
        </ListItem>
      )}

      {(permissions.includes("MEA") || permissions.includes("MF")) && (
        <ListItem button onClick={handleFeatureAccessClick} component={"ul"}>
          <ListItemIcon>
            <GroupAdd />
          </ListItemIcon>
          <ListItemText primary="Feature Access" />
        </ListItem>
      )}

      {(permissions.includes("MSP") || permissions.includes("MP")) && (
        <ListItem button onClick={handlePartnersClick} component={"ul"}>
          <ListItemIcon>
            <SupervisedUserCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Manage Partners" />
        </ListItem>
      )}

      <ListItem
        button
        onClick={() => {
          window.open(
            "https://pocketradar.atlassian.net/servicedesk/customer/portals"
          );
        }}
        component={"ul"}
      >
        <ListItemIcon>
          <RoomServiceIcon />
        </ListItemIcon>
        <ListItemText primary="Service Desk" />
      </ListItem>
    </div>
  );
};
